'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pdf_link_service = require('pdfjs-dist/lib/web/pdf_link_service');

exports.default = _pdf_link_service.PDFLinkService;


//////////////////
// WEBPACK FOOTER
// ./~/react-pdf/dist/LinkService.js
// module id = 820
// module chunks = 1